import {
    TableFooter as MuiTableFooter,
    TableCell,
    TableRow,
    Typography
} from "@material-ui/core";

interface ITableFooter {
    colSpan: number;
    count: number;
    helperText?: string;
}

function TableFooter({ colSpan, count, helperText }: ITableFooter) {
    const hasHelperCell = !!helperText && colSpan >= 2;

    return (
        <MuiTableFooter>
            <TableRow>
                {hasHelperCell && (
                    <TableCell
                        colSpan={colSpan - 1}
                        style={{ borderColor: "transparent" }}
                    >
                        <Typography
                            variant="caption"
                            style={{ fontWeight: "bold" }}
                        >
                            {helperText}
                        </Typography>
                    </TableCell>
                )}
                <TableCell
                    colSpan={hasHelperCell ? 1 : colSpan}
                    align="right"
                    style={{ borderColor: "transparent" }}
                >
                    <Typography variant="caption">
                        {`Total: ${count}`}
                    </Typography>
                </TableCell>
            </TableRow>
        </MuiTableFooter>
    );
}

export default TableFooter;
